module.exports = __webpack_public_path__ + "static/media/GianduiaNatural.7ede5c3a.png";